import { connect } from "react-redux";
import { sessionSlice } from "../../store/sessionSlice";
import HomeView from "../views/home";

const mapStateToProps = (state) => {
  return {
    isConnected: state.session.isConnected,
    isConnectedToASession: state.session.sessionStatus === "ACTIVE" || state.session.sessionStatus === "MINIMIZING",
    isLoading: state.session.sessionStatus === "LOADING_ROOM" || state.session.sessionStatus === "LOADING_SCENE",
    isEstablishingConnection: state.session.isEstablishingConnection,
    connectionQuality: state.session.connectionQuality,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onStartConnecting: (data) => {
      dispatch(sessionSlice.actions.startConnecting());
    },
    onRetry: () => {
      dispatch(sessionSlice.actions.qualityTestReset());
      dispatch(sessionSlice.actions.startConnecting());
    },
  };
};
export const HomeViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeView);
